export const GF_LOGIC = {
  ANY: 'any',
  ALL: 'all',
}

export const GF_LOGIC_ACTION = {
  SHOW: 'show',
  HIDE: 'hide',
}

export const GF_LOGIC_OPERATOR = {
  EQUAL: 'is',
  NOT_EQUAL: 'isnot',
  GREATER: '>',
  SMALLER: '<',
  CONTAINS: 'contains',
  START: 'starts_with',
  END: 'ends_with',
}

export const KEYDOWN_EVENTS = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  BACKSPACE: 8,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  HOME: 36,
  END: 35,
  TAB: 9,
}

export const HIDDEN_FIELDS = {
  TRANSACTION_ID: 'gfformv3-buildingblocks-transactionid',
  USER_ID: 'gfformv3-buildingblocks-userid',
  PRODUCT_IDS: 'gfformv3-buildingblocks-postids',
  PRODUCT_GIDS: 'gfformv3-buildingblocks-gids',
}

export const REQUEST_FORM_TITLES = [
  'Requestform V3',
  'Requestform V4',
  'RequestForm V3',
  'RequestForm V4',
  'Anfrageformular V3',
]

export const BOOKING_FORM_TITLES = [
  'Bookingform v3 - GF',
  'Buchungsformular v3 - GF',
]

export const ENQUIRY_MODAL_TITLES = ['What are your holiday plans?']

export const TRAVELPLAN_FIELD_ID = 3
